// extracted by mini-css-extract-plugin
module.exports = {"switcher":"favorites-tabs_switcher__ZBQ8j","tab":"favorites-tabs_tab__FlQgv","active":"favorites-tabs_active__b7Qk0","icon":"favorites-tabs_icon__LOEmK"};